import React, { useState, useEffect } from 'react';
import styles from './LabelChip.module.css';

interface LabelChipProps {
  label: string;
  color: string;
  size?: 'small' | 'medium';
  removable?: boolean;
  onRemove?: () => void;
  isCurrentRound?: boolean;
}

const LabelChip: React.FC<LabelChipProps> = ({ 
  label, 
  color, 
  size = 'small', 
  removable = false,
  onRemove,
  isCurrentRound = true,
}) => {
  const [isHovered, setIsHovered] = useState(false);
  const [showRemoveButton, setShowRemoveButton] = useState(false);

  useEffect(() => {
    let timeoutId: NodeJS.Timeout;

    if (isHovered) {
      // Only show remove button after 300ms of hover
      timeoutId = setTimeout(() => {
        setShowRemoveButton(true);
      }, 300);
    } else {
      // Hide immediately when not hovered
      setShowRemoveButton(false);
    }

    return () => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    };
  }, [isHovered]);

  const handleRemoveClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (onRemove) {
      onRemove();
    }
  };

  return (
    <span 
      className={`${styles.labelChip} ${styles[size]} ${removable ? styles.removable : ''} ${!isCurrentRound ? styles.notCurrentRound : ''}`}
      style={{ backgroundColor: color }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <span className={styles.labelText}>
        {label.toUpperCase()}
      </span>
      {removable && (
        <button
          className={`${styles.removeButton} ${showRemoveButton ? styles.visible : ''}`}
          onClick={handleRemoveClick}
          title="Remove label"
        >
          <i className="bi bi-x"></i>
        </button>
      )}
    </span>
  );
};

export default LabelChip; 